import * as z from 'zod';

export const annualIncomeSchema = z.number();
